import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useLoader } from '../../hooks/useLoader';
import { resetNewPassword } from '../../services/authService';
import './ResetPassword.css';

const ResetPassword = () => {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const [searchParams] = useSearchParams();
  // Get a single query param
  const token = searchParams.get('token'); // ?name=John → "John"

  const { showLoading } = useLoader();
  const navigate = useNavigate();
  const validateForm = () => {
    const newErrors: { [key: string]: string } = {};

    if (newPassword.length < 6) {
      newErrors.newPassword = 'Password must be at least 6 characters long';
    }

    if (newPassword !== confirmPassword) {
      newErrors.confirmPassword = 'Passwords do not match';
    }

    if (!newPassword) {
      newErrors.newPassword = 'New password is required';
    }

    if (!confirmPassword) {
      newErrors.confirmPassword = 'Please confirm your password';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!validateForm() || !token) {
      return;
    }

    try {
      showLoading(true);

      await resetNewPassword({
        newPassword: newPassword,
        token: token, // from URL params or props
      });

      showLoading(false);
      alert('Password has been reset successfully! Please login to continue.');
      navigate('/');
    } catch (error) {
      showLoading(false);
      alert('Failed to reset password. Please try again.');
      console.error('Password reset error:', error);
    }
  };

  return (
    <div className='reset-password-container'>
      <div className='reset-password-content'>
        <div className='logo-container'>
          <img src='/assets/logo_main.png' alt='Logo' className='logo' />
        </div>

        <h2 className='reset-password-heading'>Reset Your Password</h2>
        <p className='reset-password-subtext'>
          Enter your new password below to complete the reset process.
        </p>

        <form className='reset-password-form' onSubmit={handleSubmit}>
          <div className='form-group'>
            <label htmlFor='new-password' className='form-label'>
              New Password
            </label>
            <input
              type='password'
              id='new-password'
              name='new-password'
              className={`form-input ${errors.newPassword ? 'error' : ''}`}
              placeholder='Enter your new password'
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
            />
            {errors.newPassword && (
              <span className='error-message'>{errors.newPassword}</span>
            )}
          </div>

          <div className='form-group'>
            <label htmlFor='confirm-password' className='form-label'>
              Confirm Password
            </label>
            <input
              type='password'
              id='confirm-password'
              name='confirm-password'
              className={`form-input ${errors.confirmPassword ? 'error' : ''}`}
              placeholder='Confirm your new password'
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
            {errors.confirmPassword && (
              <span className='error-message'>{errors.confirmPassword}</span>
            )}
          </div>

          <button
            type='submit'
            className='submit-btn'
            disabled={!newPassword || !confirmPassword}
          >
            Reset Password
          </button>
        </form>

        <div className='back-to-login'>
          <span onClick={() => navigate('/')} className='back-link'>
            ← Back to Home
          </span>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
